import { ForgotPasswordTemplate } from '@/templates'

const ForgotPassword = (): JSX.Element => {
  return <ForgotPasswordTemplate />
}

export default ForgotPassword
